import React, { useMemo, memo } from "react";
// helpers
import { isEmpty } from "@swiggy-private/core-ui";
// components
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
// styles
import { Wrapper, InfoIconWrapper } from "./styles";
import { MenuItemsCalloutHalfCardTrigger } from "../menu-items-callout";
// constants
import { GIFTING_MULTI_DELIVERY_INFO_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { MenuItemsCalloutInfo } from "@swiggy-private/cart-types";
// utils
import { replaceDeliveryCountPlaceHolderInMessage } from "./utils";

const GiftingCartMultiDeliveryInfo = ({
    multiDeliveryInfo,
    deliveryCount = 0,
}: {
    multiDeliveryInfo?: MenuItemsCalloutInfo;
    deliveryCount: number;
}) => {
    const halfCardDataAvailable = useMemo(() => {
        return (
            !isEmpty(multiDeliveryInfo?.half_card_trigger_text) && !isEmpty(multiDeliveryInfo?.half_card_info?.title)
        );
    }, [multiDeliveryInfo]);

    const multiDeliveryInfoMessage = useMemo(() => {
        return replaceDeliveryCountPlaceHolderInMessage(multiDeliveryInfo?.message, deliveryCount);
    }, [multiDeliveryInfo, deliveryCount]);

    if (isEmpty(multiDeliveryInfo?.message) || deliveryCount <= 1) {
        return null;
    }

    return (
        <Wrapper data-testid={GIFTING_MULTI_DELIVERY_INFO_DATA_TEST_IDS.CONTAINER}>
            <InfoIconWrapper>
                <SpriteIconWeb iconName="info16" fillColor="text_Low_Emphasis" strokeColor="text_Low_Emphasis" />
            </InfoIconWrapper>
            <Text
                variant="V2.body3.neutral.regular"
                color="text_Med_Emphasis"
                data-testid={GIFTING_MULTI_DELIVERY_INFO_DATA_TEST_IDS.TEXT}
            >
                {multiDeliveryInfoMessage}
                {halfCardDataAvailable && (
                    <>
                        <MenuItemsCalloutHalfCardTrigger
                            isGiftingCart={true}
                            dataTestId={GIFTING_MULTI_DELIVERY_INFO_DATA_TEST_IDS.CTA}
                            calloutInfo={multiDeliveryInfo}
                            hideTriggerCTABorder={true}
                            triggerCTAColor="primary"
                        />
                    </>
                )}
            </Text>
        </Wrapper>
    );
};

export default memo(GiftingCartMultiDeliveryInfo);
